document.addEventListener('DOMContentLoaded', () => {

    function isEmpty(obj) {
        return !obj || Object.keys(obj).length === 0;
    }

    const popSearchValue = document.querySelector('#popSearchValue')
    const popSearchContainer = document.querySelector('#popSearchContainer')

    const csEvents = ['input', 'paste'];
    let csDebounceTimeout;

    csEvents.forEach(event => {
        popSearchValue.addEventListener(event, () => {
        clearTimeout(csDebounceTimeout);
        csDebounceTimeout = setTimeout(() => {
            csSearchFunction();
        }, 100);
      });
    });

    async function csSearchFunction() {
    if (popSearchValue.value !== '') {
      try {
        popSearchContainer.innerHTML = `Loading...`;
  
        // Define all fetch requests
        const searchRequest = fetch(
          window.Shopify.routes.root + `search/suggest.json?q=${popSearchValue.value}&resources[type]=product`
        );
        const inventoryRequest = fetch(
          window.Shopify.routes.root + `products/${popSearchValue.value}/?view=json`
        );
  
        // Wait for all fetch requests to resolve
        const [searchResponse, inventoryResponse] = await Promise.all([
          searchRequest,
          inventoryRequest
        ]);
  
        const suggestions = await searchResponse.json();
        const products = suggestions.resources.results.products || [];
        const collections = suggestions.resources.results.collections || [];
  
        let inventoryRes = null;
        if (inventoryResponse.ok) {
          inventoryRes = await inventoryResponse.json();
          console.log("Inventory Response:", inventoryRes);
        } else {
          console.warn(`Skipping inventory: API returned status ${inventoryResponse.status}`);
        }
  
        let div = '';
  
        if (isEmpty(products) && isEmpty(collections) && !inventoryRes) {
          div += `<p>No results found...</p>`;
        } else {
          div += `<div class="cs-grid">`;
  
          // Inventory-based section (if available)
          if (inventoryRes) {
            div += `<p>Inventory Based</p>`;
            div += `<div class="cs-product">`;
            div += `<div class="cs-image"><img src="${inventoryRes.image}" /></div>`;
            div += `<p><a href="${inventoryRes.url}">${inventoryRes.title}</a></p>`;            
            div += `</div>`;
          }
  
          // Products Section
          if (!isEmpty(products)) {
            div += `<p>Products</p>`;
            const productPromises = products.map(async (product) => {
              if (product.image && product.title) {
                const productRes = await fetch(
                  window.Shopify.routes.root + `products/${product.handle}/?view=json`
                );
                const res = await productRes.json();
  
                return `
                  <div class="cs-product">
                    <div class="cs-image"><img src="${product.image}" /></div>
                    <p><a href="${product.url}">${product.title}</a></p>                    
                  </div>`;
              }
              return '';
            });
  
            div += (await Promise.all(productPromises)).join('');
          }
  
          // Collections Section
          if (!isEmpty(collections)) {
            div += `<p>Collections</p>`;
            div += collections
              .map(
                (collection) =>
                  `<div class="cs-collection">
                     <p><a href="${collection.url}">${collection.title}</a></p>
                   </div>`
              )
              .join('');
          }
  
          div += `</div>`;
        }
  
        popSearchContainer.innerHTML = div;
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
    } else {
        popSearchContainer.innerHTML = `No Results`
    }
    }

})